import React, { useState } from "react";
import { Box, Collapse, IconButton } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useResponsiveFontSize } from "../functions";

const FAQs = ({ faqs }) => {
  // State to track which FAQ item is currently expanded
  const [expandedIndex, setExpandedIndex] = useState(null);

  // Function to handle expanding and collapsing the answer
  const handleExpand = (index) => {
    // If the clicked index is the same as the current expanded index, collapse it; otherwise, expand it
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  const fontSize = useResponsiveFontSize();
  return (
    <Box sx={{ width: "100%", maxWidth: "600px", margin: "auto" }}>
      {faqs.map((faq, index) => (
        <Box
          key={index}
          sx={{
            borderBottom: "1px solid #ddd",
            padding: "1rem 0",
            cursor: "pointer",
            fontSize: fontSize,
          }}
        >
          {/* Question Section */}
          <Box
            onClick={() => handleExpand(index)}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Box
              sx={{
                fontWeight: expandedIndex === index ? "300" : "100",
              }}
            >
              {faq.question}
            </Box>
            <IconButton
              onClick={() => handleExpand(index)}
              aria-expanded={expandedIndex === index}
              aria-label="show more"
              sx={{
                transform:
                  expandedIndex === index ? "rotate(180deg)" : "rotate(0deg)",
                transition: "transform 0.3s ease",
              }}
            >
              <ExpandMoreIcon />
            </IconButton>
          </Box>

          {/* Answer Section */}
          <Collapse in={expandedIndex === index} timeout="auto" unmountOnExit>
            <Box
              sx={{
                padding: "1rem 0",
                marginLeft: "0.5rem",
                fontWeight: "100",
              }}
            >
              {faq.answer}
            </Box>
          </Collapse>
        </Box>
      ))}
    </Box>
  );
};

export default FAQs;
